module.exports = __webpack_public_path__ + "img/consult_info2.3088862a.png";